import { render, staticRenderFns } from "./HEADLINE.vue?vue&type=template&id=4a8e768e&scoped=true&"
import script from "./HEADLINE.vue?vue&type=script&lang=js&"
export * from "./HEADLINE.vue?vue&type=script&lang=js&"
import style0 from "./HEADLINE.vue?vue&type=style&index=0&id=4a8e768e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8e768e",
  null
  
)

export default component.exports